import { getAuthToken } from "../../../auth/authClient";

const API_BASE = (process.env.REACT_APP_MORFEUSZ_4E_API_URL || "").replace(/\/$/, "");

const symbolsUrl = (path = "") => `${API_BASE}/symbols${path}`;

const requestHeaders = (options = {}) => {
  const token = getAuthToken();
  return {
    ...(options.body ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };
};

const parseResponse = async (response) => {
  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.ok) {
    const error = new Error(data?.message || `symbols-http-${response.status}`);
    error.code = data?.code || `symbols-http-${response.status}`;
    error.status = response.status;
    error.response = data || null;
    throw error;
  }
  return data;
};

const request = async (path = "", options = {}) => {
  if (!API_BASE) {
    const error = new Error("symbols-api-missing");
    error.code = "symbols-api-missing";
    throw error;
  }

  const response = await fetch(symbolsUrl(path), {
    credentials: "include",
    ...options,
    headers: requestHeaders(options),
  });
  return parseResponse(response);
};

export const symbolsClient = {
  isConfigured: () => Boolean(API_BASE),
  status: () => request("/status"),
  interpret: ({ terms, context = "", language = "pl" }) => request("/interpret", {
    method: "POST",
    body: JSON.stringify({ terms, context, language }),
  }),
};
